import React from 'react';
import Link from "next/link";

import styles from "./RenderTags.module.css";

const RenderTags = (props) => {
  if (!props || !props.tags) return null;

  return props.tags.map((tag, index) => {
    return tag && (
      <div className={styles["tags"]} key={"tag_" + index}>
        <Link href={"/tags/" + encodeURIComponent(tag.name)}>
          <span className={styles["tags-item"]}>{tag.name}</span>
        </Link>
      </div>
    );
  });
};

export default RenderTags;
